import React, { useEffect, useState } from 'react'
import Section from '../../../components/section'
import Text from '../../../components/text'
import Flex from '../../../components/flex'
import Button from '../../../components/button'
import {useFormik} from "formik";
import * as Yup from "yup";
import Input from '../../../components/input'
import PhoneInput from 'react-phone-number-input'
import useLogin from '../../authentication/login/hooks/login.hook'
import Checkbox from "../../../components/checkbox";
import Image from '../../../components/image'
import AccessCardDigitsImg from '../../../assets/images/millennium-access-card-digits.jpg';

const ProfileView = (props) => {
    const {
        profileInfo,
        updateProfile,
        garagesList
    } = props
    const {
        phoneNumbersFormat
    } = useLogin()

    const [phoneNumber, setPhoneNumber] = useState(profileInfo?.mobile);

    const handleCheckboxChange = (e)=>{
        let newValue = formik.values.garage ?? []
        let val = e.target.value

        let value = typeof e.target.value === 'number' ? val : +val
        if(e.target.checked) {
            newValue.push(value)
        } else {
            const index = newValue.indexOf(value);
            if (index > -1) {
                newValue.splice(index, 1);
            }
        }
        formik.setFieldValue('garage', newValue)
    }

    const formik = useFormik({
        initialValues: {
            uname: profileInfo?.email,
            firstName: profileInfo?.first_name,
            lastName: profileInfo?.last_name,
            companyName: profileInfo?.company_name,
            mobile: profileInfo?.mobile,
            parkingNumber: profileInfo?.access_card_number,
            garage: profileInfo?.garages
        },
        validationSchema: Yup.object({
            uname: Yup.string().required('Please enter a valid email address'),
            firstName: Yup.string().required('Please enter a valid first name'),
            lastName: Yup.string().required('Please enter a valid last name'), 
            companyName: Yup.string().max(50,"Company name can not be more than 50 characters"),
            mobile: Yup.string()
                .required('Please enter mobile number')
                .min(10, 'Please enter a valid mobile number')
                .max(13, 'Please enter a valid mobile number')
                .matches(phoneNumbersFormat, 'Please enter a number'),
            parkingNumber: Yup.string().required('Please enter access card number'),
            garage:Yup.array().max(1,'Please select only one Garage').min(1,"Please select one Garage"),
            
        }),
        onSubmit: (values, actions) => {
            const body = {
                first_name: values?.firstName ,
                last_name:values?.lastName ,
                company_name:values?.companyName ,
                mobile:values?.mobile ,
                email:values?.uname ,
                access_card_number: values?.parkingNumber,
                garage_ids: values?.garage
            }
            updateProfile(body, actions)
        }
    });


    useEffect(() => {
        if(phoneNumber) {
            formik.setFieldValue('mobile', phoneNumber)
        }
    }, [phoneNumber])
    return (
        <Section>
            <Text type="H1" text="Edit Account Profile" />
            <form onSubmit={formik.handleSubmit}>

                <div className="row">
                    <div className="col-12 col-md-6">
                        <div className="formBox">
                            <Input
                                label="Email Address"
                                type="email"
                                name="uname"
                                placeholder="Your Email Address"
                                autoFocus={true}
                                value={formik.values.uname}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                mandatory
                                errormessage={formik.touched.uname && formik.errors.uname ? (
                                    formik.errors.uname
                                ) : null}
                            />
                        </div>
                    </div>
                    <div className="col-12 col-md-6">
                        <div className="formBox">
                            <div className="form-field">
                                <label className="form-label">Mobile number <span
                                    className="text-danger">*</span></label>
                                <PhoneInput
                                    className={formik.touched.mobile && formik.errors.mobile ? 'error' : ''}
                                    defaultCountry={'US'}
                                    countries={['US']}
                                    placeholder="Enter mobile number"
                                    value={phoneNumber}
                                    onChange={setPhoneNumber}
                                    countryCallingCodeEditable={false}
                                    addInternationalOption={false}
                                    limitMaxLength="10"
                                    international
                                />
                            </div>
                            <div className="formBox hiddenInput">
                                <Input
                                    type="hidden"
                                    maxlength="10"
                                    name="mobile"
                                    placeholder=""
                                    mandatory
                                    value={formik.values.mobile}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    errormessage={formik.touched.mobile && formik.errors.mobile ? (
                                        formik.errors.mobile
                                    ) : null}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6">
                        <div className="formBox">
                            <Input
                                label="First Name"
                                type="text"
                                name="firstName"
                                placeholder="Your First name"
                                autoFocus={true}
                                value={formik.values.firstName}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                mandatory
                                errormessage={formik.touched.firstName && formik.errors.firstName ? (
                                    formik.errors.firstName
                                ) : null}
                            />
                        </div>
                    </div>
                    <div className="col-12 col-md-6">
                        <div className="formBox">
                            <Input
                                label="Last Name"
                                type="text"
                                name="lastName"
                                placeholder="Your Last name"
                                autoFocus={true}
                                value={formik.values.lastName}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                mandatory
                                errormessage={formik.touched.lastName && formik.errors.lastName ? (
                                    formik.errors.lastName
                                ) : null}
                            />
                        </div>
                    </div>
                    <div className="col-12 col-md-12">
                        <div className="formBox">
                            <Input
                                label="Company / Organization"
                                type="text"
                                name="companyName"
                                placeholder="Your Company name"
                                autoFocus={true}
                                value={formik.values.companyName}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                errormessage={formik.touched.companyName && formik.errors.companyName ? (
                                    formik.errors.companyName
                                ) : null}
                            />
                        </div>
                    </div>
                    <div className="col-12 col-md-6">
                        <div className="input-ticket-card">
                            <div className="input-ticket-heading">
                                <div className="ith-left">
                                    <Text
                                        type="H4"
                                        className="ith-subtitle mb-0"
                                        text="Access Card Number"
                                    />
                                </div>
                                <div className="ith-right">
                                    <Text
                                        type="PARAGRAPH"
                                        className="mb-0"
                                        text="To link your profile to an existing account, please type the first sequence of numbers printed on your garage access card (up to 5 digits).  If unavailable, type “00000”."
                                    />
                                </div>
                            </div>
                            <div className="formBox">
                                <Input
                                    mb0
                                    type="text"
                                    name="parkingNumber"
                                    placeholder="Your access card number"
                                    mandatory
                                    
                                    value={formik.values.parkingNumber}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    errormessage={formik.touched.parkingNumber && formik.errors.parkingNumber ? (
                                        formik.errors.parkingNumber
                                    ) : null}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-3">
                        <Image
                            src={AccessCardDigitsImg} 
                            alt="Access Card Digits"
                            className="border-img" 
                        />
                    </div>
                    <div className="col-12 col-md-12">
                        <div className="formBox">
                            <Text type="PARAGRAPH" className="form-label font-weight-500 mb-1" text="Please indicate which of the following garage you want to include with your Flex Daily Subscription." />
                            <Text type="PARAGRAPH" className="form-label" text="Note: Flex Daily parking rates may vary by location" />

                            {garagesList?.map((item, index) => {
                                let finalId = typeof item.id === 'number' ? item.id : +item.id
                                const checked = formik?.values?.garage?.includes(finalId)
                                return(
                                    <div className="col-12 col-md-6" key={'garage'+index}>
                                        <Checkbox
                                            name="garage"
                                            value={item.id}
                                            label={item.location}
                                            id={item.id}
                                            isChecked={checked}
                                            onChange={handleCheckboxChange}
                                            errormessage={formik.touched.garage && formik.errors.garage ? (
                                                formik.errors.garage
                                            ) : null}
                                        />
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>

                <Flex justifyContent="center" className="mb-48 gap-3">
                    <Button
                        type="submit"
                        text="Update"
                        large
                        isSubmitting={formik.isSubmitting}
                        disabled={formik.isSubmitting}
                    />
                    <Button
                        outline
                        large
                        text="Cancel"
                        type="button"
                    />
                </Flex>
            </form>
        </Section>
    )
}

export default ProfileView